import { chatKeys } from "@/modules/chat/gateway/chatKeys"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useQuery } from "@tanstack/react-query"

export function useChatToken() {
  const { chatApi } = useServicesContext()

  return useQuery({
    queryKey: chatKeys.token(),
    queryFn: async () => {
      return await chatApi.getChatToken()
    },
  })
}
